__turbopack_context__.v({
  "backdrop": "Modal-module-scss-module__o5PEPq__backdrop",
  "close": "Modal-module-scss-module__o5PEPq__close",
  "modal": "Modal-module-scss-module__o5PEPq__modal",
});
